import type { ComponentType } from 'react';
import {
  FacebookIcon,
  GoogleIcon,
} from '@/components/icons/social/SocialProviderIcons';

export type SupportedProvider = 'facebook' | 'google';

export type SocialProviderIcon = ComponentType<{ className?: string }>;

export type SocialProviderConfig = {
  provider: SupportedProvider;
  label: string;
  icon: SocialProviderIcon;
};

export const SOCIAL_PROVIDERS: SocialProviderConfig[] = [
  {
    provider: 'google',
    label: 'Continue with Google',
    icon: GoogleIcon,
  },
  {
    provider: 'facebook',
    label: 'Continue with Facebook',
    icon: FacebookIcon,
  },
];
